import { IChain } from '../libs/shared/data-access/interfaces/src/lib/chain.interface';

export const chain: IChain = {
	aemData: {
		title: 'Read More',
		subText: 'Latest From Field Guide'
	},
	authStrategy: 'cookie',
	bopisFlag: true,
	bopisLocationDefault: -4,
	cartUrlParameters: '?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-3&calculationUsageId=-7&updatePrices=1&doConfigurationValidation=Y&catalogId=20310&orderId=.&langId=-1&storeId=16066',
	checkoutUrlBase: 'SinglePageCheckout',
	checkoutUrlParameters: '?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-3&calculationUsageId=-7&updatePrices=1&doConfigurationValidation=Y&catalogId=20310&orderId=.&langId=-1&storeId=16066',
	checkoutConfirmationUrlParameters: 'catalogId=20310&langId=-1&storeId=16066',
	catalogIdCollections: '20310',
	catalogIdContent: '20310',
	catalogIdSales: '20310',
	chainIdentifier: 'PublicLands',
	chainIdentifierAbbr: 'pl',
	chainMarketingIdentifierAbbr: 'pl',
	chainIdentifierCookie: '161',
	chainIdentifierCookieAOS: '162',
	chainInitial: 'P',
	chainName: 'Public Lands',
	chainCartImage: 'pl_cart.svg',
	chainCartUrl: '/OrderItemDisplay',
	chainBopisIcon: 'DSGBopis.svg',
	chatUrl: 'https://dsgcep.custhelp.com/app/chat/chat_launch',
	crossChainBopisPartners: ['dsg'],
	crossChainLogoSVG: {
		dickssportinggoods: 'store_pickup.svg'
	},
	holidayOfferCode: 'EM1219DBP3X',
	isaFlag: true,
	logoSVG: 'pl_logo.svg',
	masterCatalogId: '10001',
	metaCanonical: 'https://www.publiclands.com',
	metaCanonicalHost: 'publiclands',
	metaDescription: 'Our purpose is to celebrate and protect public lands for all. Don\'t just take our word for it. We believe in leading through action, the power of our community and welcoming everyone to experience the outdoors. That\'s what you can expect from us today and every day after.',
	metaTitle: 'Public Lands | Your Hub For The Outdoors',
	myAccountUrlLoggedIn: '/MyAccount/AccountSummary',
	myAccountUrlAuthListSignIn: '/MyAccount/Lists',
	myAccountUrlLoggedOut: '/LogonForm',
	nestjsProductAPIVersion: 'v6',
	priceStringIndicator: 'dickssportinggoods',
	productAPIVersion: 'v5',
	proTipsFlag: true,
	qAndAFlag: false,
	rewardsAccountName: 'Public Lands Hub',
	rewardsAccountImage: 'public_lands_hub.svg',
	searchDex: {
		includeType: {
			meta: 'm',
			body: 'b',
			footer: 'f'
		},
		pageType: {
			category: 'c',
			product: 'p'
		}
	},
	serviceIdentifier: 'publiclands',
	serviceIdentifierAbbr: 'pl',
	sessionCamIdentifier: 'RES-PDP-PL',
	storeId: '16066',
	userRegistrationFormUrl: '/UserRegistrationForm?new=Y&catalogId=12301&myAcctMain=1&langId=-1&storeId=15108',
	footerData: {
		social: {
			youtube: '',
			twitter: 'https://twitter.com',
			facebook: 'https://www.facebook.com',
			pinterest: 'https://www.pinterest.com',
			instagram: 'https://www.instagram.com',
			tiktok: 'https://www.tiktok.com/@publiclandsshop'
		},
		oracleChat: 'https://dsgcep.custhelp.com/app/chat/chat_launch',
		copyright: `&copy; ${new Date().getFullYear()} Public Lands`
	},
	feedbackSurveyId: '7173',
	sizeChartSurveyId: '16835',
	cartTitle: 'Cart',
	vhHeader: '161',
	auth0: {
		enabled: true
	},
	chainFooterUrls: {
		returns: {
			text: 'Returns',
			link: '/s/return-policy'
		},
		shippingRates: null,
		productAvailability: null,
		promoExclusions: null,
		contactCustomerService: null,
		privacyPolicy: {
			text: 'Privacy Policy',
			link: '/s/privacy-policy'
		},
		termsOfUse: {
			text: 'Terms of Use',
			link: '/s/terms-of-use'
		},
		californiaDisclosures: {
			text: 'California Disclosures',
			link: '/s/california-disclosures'
		},
		doNotSellMyInfoCAResidentsOnly: {
			text: 'Your Privacy Choices',
			link: '/s/donotsell'
		},
		accessibilityPolicy: {
			text: 'Accessibility Policy',
			link: '/s/accessibility-policy'
		}
	},
	shippingIcon: 'plTruck.svg',
	shippingInfoIcon: 'info',
	apiVersion: 2,
	seoIdentifier: 'publiclands',
	rewards: {
		image: 'public_lands_hub.svg',
		programName: 'Public Lands Hub'
	},
	xChannel: '',
	supportNumber: '877‑846‑9997',
	simpleHeaderLogoUrl: 'https://images.dickssportinggoods.com/marketing/pl_logo.svg',
	partyServiceId: 10,
	preferenceIds: {
		brand: 3,
		size: 6,
		color: 9
	},
};
